module.exports = __webpack_public_path__ + "static/img/cyfw_index_3_2.a53e7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cyfw_index_3_2.png
// module id = zIWW
// module chunks = 1